<template>
  <div class="form-item">
    <span v-if="title" class="form-item__title">{{ title }}</span>
    <div v-click-outside="close" class="form-item__block">
      <span v-if="error" class="form-item__error">{{ error }}</span>
      <div class="form-item__select select" @click="toggleOpen">
        <p v-if="courseSelect" class="ajax__line ajax__line-table-text"></p>
        <p v-else class="select__text" :class="valueData ? '' : 'select__text-placeholder'">
          {{ valueData && valueData.name ? 'Курс: ' + valueData.name : placeholder }}
        </p>
      </div>
      <SlideUpDown class="select__slider" :duration="slideDuration" :active="isOpen">
        <div class="select__field">
          <Input
            v-model="searchText"
            placeholder="Введите продукт"
            style="margin-bottom: 5px"
          ></Input>
          <div v-for="(item, itemIdx) in data" :key="item.folder.id" class="folders-select__list">
            <label class="folders-select__row -folder-" style="flex-flow: row">
              <span class="folders-select__folder"> Папка: {{ item.folder.name }} </span>
            </label>
            <label
              v-for="(course, courseIdx) in item.courseArray"
              :key="course.id"
              class="folders-select__row -course-"
              style="flex-flow: row"
              @click="selectCourse(course)"
            >
              <span class="folders-select__text">{{ course.name }}</span>
            </label>
          </div>
        </div>
      </SlideUpDown>
      <Icon
        v-if="valueData && valueData.name"
        class="form-item__delete"
        icon="input-delete"
        @click="clearInput"
      ></Icon>
      <Icon
        v-else
        class="select__icon form-item__icon"
        :icon="!icon ? 'arrow-down' : icon"
        :class="{ '-opened-': isOpen }"
        @click="toggleOpen"
      ></Icon>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import SlideUpDown from 'vue-slide-up-down';
import vClickOutside from 'v-click-outside';
import { mapState, mapActions } from 'vuex';

export default {
  name: 'Select',
  components: {
    SlideUpDown
  },
  directives: {
    clickOutside: vClickOutside.directive
  },
  props: {
    title: {},
    placeholder: {},
    error: {},
    icon: {},
    value: {},
    selected: {}
  },
  data() {
    return {
      searchText: '',
      data: {},
      isOpen: false,
      slideDuration: 200,
      status: false,
      arrayId: [],
      courseSelected: '',
      valueData: {}
    };
  },
  computed: {
    ...mapState('usersGroups', {
      folders: s => s.aside.data.folders,
      courseSelect: s => s.aside.meta.courseSelect
    }),
    ...mapState('users', {
      selectedData: s => s.data.selectedData
    })
  },
  watch: {
    folders() {
      this.setData();
    },
    value() {
      this.setData();
    },
    selectedData() {
      this.setData();
    },
    searchText(val) {
      if (val) {
        this.data = _.cloneDeep(this.folders)
          .map(item => {
            const regex = new RegExp(this.searchText, 'gi');

            let obj = {};
            if (item.courseArray.some(c => regex.test(c.name))) {
              obj = {
                folder: item.folder,
                courseArray: item.courseArray.filter(c => {
                  const regex1 = new RegExp(this.searchText, 'gi');
                  return regex1.test(c.name);
                })
              };
            }

            return obj;
          })
          .filter(el => el.courseArray);
      } else {
        this.setData();
      }
    }
  },
  mounted() {
    if (this.folders.length == 0) {
      this.getCourseSelect();
    }

    this.setData();
  },
  methods: {
    ...mapActions('usersGroups', ['getCourseSelect']),
    setData() {
      this.data = _.cloneDeep(this.folders).map(el => {
        if (el.courseArray.length > 0) {
          const data = el.courseArray.filter(elem => {
            if (elem.id == this.value || !this.value) {
              this.valueData = this.value ? elem : '';
            }

            if (!this.selectedData.some(item => item == elem.id)) {
              return el;
            }
          });
          el.courseArray = data;
        }
        return { ...el };
      });
    },
    toggleChecked(itemIdx, idx) {
      const data = _.cloneDeep(this.data);
      const item = data[itemIdx];
      const arrayId = [];
      if (idx) {
        item.courseArray[idx].checked = !item.courseArray[idx].checked;
        item.folder.checked = false;
      } else {
        if (item.folder.checked) {
          item.folder.checked = false;
        } else {
          item.folder.checked = true;
          item.courseArray.forEach(el => {
            arrayId.push(el.id);
            el.checked = true;
          });
        }
      }
      this.data = { ...data };
      // this.$emit('update:courseFolders', newCourseFolders)
    },
    selectCourse(course) {
      if (this.courseSelected) {
        this.$store.dispatch('users/setSelectedCourse', {
          id: this.courseSelected,
          remove: true
        });
      }
      this.courseSelected = course.id;
      this.setEmit();
    },
    clearInput() {
      this.setEmit(true);
      this.courseSelected = '';
    },
    setEmit(remove = false) {
      this.$store.dispatch('users/setSelectedCourse', {
        id: this.courseSelected,
        remove: remove
      });
      this.$emit('input', remove ? '' : this.courseSelected);
      this.close();
    },
    toggleOpen() {
      if (this.folders.length > 0) {
        this.isOpen = !this.isOpen;
      }
    },
    close() {
      this.isOpen = false;
      this.searchText = '';
    }
  }
};
</script>
